export default __webpack_public_path__ + "static/media/bubble_zoomcall.36fd078a.mp3";